const focusStyles = {
    default: `
    iris:focus-visible:outline-none
    iris:focus-visible:ring-2
    iris:focus-visible:ring-offset-2
    iris:focus-visible:ring-(--sem-color-border-interactive-selected)
    iris:focus-visible:transition-[ring_var(--comp-motion-duration-focus-ring)_var(--comp-motion-easing-focus-ring)]
  `,
    inverse: `
    iris:focus-visible:outline-none
    iris:focus-visible:ring-2
    iris:focus-visible:ring-offset-2
    iris:focus-visible:ring-(--sem-color-border-interactive-inverse-selected)
    iris:focus-visible:ring-offset-(--sem-color-background-neutral-inverse-primary)
    iris:focus-visible:transition-[ring_var(--comp-motion-duration-focus-ring)_var(--comp-motion-easing-focus-ring)]
  `,
    defaultWithOutline: `
    iris:focus-visible:ring-2
    iris:focus-visible:ring-offset-2
    iris:focus-visible:ring-(--sem-color-border-interactive-selected)
    iris:focus-visible:transition-[ring_var(--comp-motion-duration-focus-ring)_var(--comp-motion-easing-focus-ring)]
  `,
    inverseWithOutline: `
    iris:focus-visible:ring-2
    iris:focus-visible:ring-offset-2
    iris:focus-visible:ring-(--sem-color-border-interactive-inverse-selected)
    iris:focus-visible:ring-offset-(--sem-color-background-neutral-inverse-primary)
    iris:focus-visible:transition-[ring_var(--comp-motion-duration-focus-ring)_var(--comp-motion-easing-focus-ring)]
  `,
};

export { focusStyles };
